export default "__VITE_ASSET__BYgIf25g__"